import React from 'react'
import { Button, Card } from '@headtrip/components-react'
import * as styles from './TutorialContributeCard.module.scss'
import classnames from 'classnames'

const TutorialContributeCard = ({ hasPromoCode }) => {
  const className = classnames(
    hasPromoCode ? styles.contributeButton : styles.maxWidthFitContent
  )
  return (
    <Card className='p-3 border-0 shadow-sm' style={{ maxWidth: '400px' }}>
      <h5 className='uppercase'>
        Want to contribute?
      </h5>
      <p>
        <strong>Get Rewarded: </strong>Get up to <strong>€50 </strong>credit on your account for every tutorial you
        write and we publish!
      </p>
      <Button
        href='https://github.com/hetzneronline/community-content?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=get_rewarded_right'
        // style={{ maxWidth: 'fit-content' }}
        className={className}
        variant='primary'
        target="_blank"
      >
        Find out more
      </Button>
    </Card>
  )
}

export default TutorialContributeCard
